export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    ConnectTo: string;
    base: string;
    url(url: string): string;
    name: string;
    author: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    card: string;
    headerLogo: string;
    footerLogo: string;
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    surveyId: string;
    hasCommercialInsuranceQuestion: string;
    hasCommercialInsuranceAnswer: string;
    is18YearsOrOlderQuestion: string;
    is18YearsOrOlderAnswer: string;
    isHealthcareProviderQuestion: string;
    isHealthcareProviderAnswer: string;
    notFederallyFundedQuestion: string;
    notFederallyFundedAnswer: string;
    triangleUp: string;
    triangleDown: string;
    lockEnabled: string;
    lockPassword: string;
    brandIdEnglish: string;
    brandIdSpanish: string;
    senderId: string;
    patientTemplateIdEnglish: string;
    patientTemplateIdSpanish: string;
    representativeTemplateIdEnglish: string;
    representativeTemplateIdSpanish: string;
    expireInDays: number;
    shouldShowToggle: string;
}
